class MeusPedidosModel {
    constructor(status, pedido, dataPedido) {
        this.status = status;
        this.pedido = pedido;
        this.dataPedido = dataPedido;
    }
    fromJson(json) {
        this.idPedido = json['idPedido'];
        this.status = json['status'];
        this.dataPedido = json['dataPedido'];
        this.pedido = new HistoricoPedidoModel().fromJson(json['historicoPedido']) // aqui vem o json_pedido
        return this
    }

    /**
     * 
     * @returns Formated date
     */
    dataBrasil() {
        if (this.dataPedido == null) {return  ""}
        if (this.dataPedido.includes("0000")) {return  ""}

        // vamos transformar o horario vindo do server, pois ele vem assim "2023-05-11 14:25:29"

        // primerio vamos pegar os hias, separando no "-"
        let split = this.dataPedido.split("-")

        // depois vamos separar os dias do horarios separando no " " (espaco)
        let split2 = split[split.length - 1].split(" ")

        // vamos crear um new Date sem hroario
        const currentDate = new Date(`${split[0]}-${split[1]}-${split2[0]} 00:00:00`);

        // agora vamos pegar os horarios separando no ":"
        let [h, m, s] = split2[1].split(":")
        h = parseInt(h, 10)
        m = parseInt(m, 10)
        s = parseInt(s, 10)

        // vamos setar o horario
        currentDate.setHours(h)
        currentDate.setMinutes(m)
        currentDate.setSeconds(s)

        // Format date using Intl.DateTimeFormat
        const formattedDate = new Intl.DateTimeFormat('pt-BR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        }).format(currentDate);
        return formattedDate
    }
}

export default MeusPedidosModel


/**
 * Aqui vem o Json do pedido salvo como json no banco
 * 
 * "pix_dados": {"qr_code": "00020126580014br.gov.bcb.pix0136fbf7dc8c-5603-470c-acff-000b454e5d0252040000530398654047.155802BR5912LEALRENNAN866009Sao Paulo62240520mpqrinter9813006107163044E09",
//  "payment_id": 98130061071,
//  "data_pedido": "2025-01-06T13:48:25.405Z",
//  "payment_method_id": "bank_transfer"}
 */
class HistoricoPedidoModel {
    constructor(data, endereco, valorTotalCarrinho, taxaEntrega, itens) {
        this.data = data
        this.qrcode = null
        this.endereco = endereco
        this.valorTotalCarrinho = valorTotalCarrinho
        this.taxaEntrega = taxaEntrega
        this.itens = itens
    }
    fromJson(json2) {
        this.data = json2['created_at'];
        if (json2['pix_dados'] != null && json2['pix_dados'] != {} && json2['pix_dados']['qr_code'] != null) {
            this.qrcode = json2['pix_dados']['qr_code']
            this.pixData = json2['pix_dados']['data_pedido']
        }
        this.endereco = json2['endereco'];
        this.valorTotalCarrinho = json2['valorTotalCarrinho'];
        this.taxaEntrega = json2['taxaEntrega'];
        this.itens = []
        for (var i = 0; i < json2.pedido.itens.length; i++) {
            var item = json2.pedido.itens[i];
            this.itens.push(new ItemPedidoModel().fromJson(item))
        }
        // console.log('Aqui vai os itens')
        // console.log(this.itens)
        return this
    }

    /**
     * 
     * @returns Formated date
     */
    dataBrasil() {
        const currentDate = new Date(this.data);

        // Format date using Intl.DateTimeFormat
        const formattedDate = new Intl.DateTimeFormat('pt-BR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'UTC', // Specify the timezone if needed
        }).format(currentDate);
        return formattedDate
    }
}

class ItemPedidoModel {
    nome;
    preco;
    quantidade;
    subitens;

    fromJson(json3) {
        this.nome  = json3['nome'];
        this.preco = json3['preco'];
        this.quantidade   = json3['quantidade'];
        this.subitens = this.pegarSubItensCombo(json3)
        return this;
    }
    pegarSubItensCombo(json){
        switch(json['tipo']){
            case "comboPorEtapa":
                return (json.subitens.map(sub => sub.nome));
            case "comboPizza":
                return (json.subitens.sabores.map(sub => sub.nome));
            case "comboPorTamanho":
                return [json.subitem.nome];
            case "comboVendaConjunta":
                return json.subitens.flatMap(sub => {
                let repetidos = [];
                for (let i = 0; i < sub.item.quantidade; i++) {
                    repetidos.push(sub.nome);
                }
                return repetidos;
            });
            default : null;
        }
    }
}